import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Input,
  Flex,
  Spinner,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useToast,
  FormControl,
  FormLabel,
  VStack,
  HStack,
  Select,
  Checkbox,
  Textarea,
  Tag,
  TagLabel,
  TagCloseButton,
  Wrap,
  WrapItem,
  Progress,
} from "@chakra-ui/react";
import { supabase } from "../../../lib/supabaseClient";
import TrackModal from "../../../components/modals/TrackModal";

const PAGE_SIZE = 20;
const columns = [
  { key: "track_name_kr", label: "트랙명" },
  { key: "track_number", label: "트랙 번호" },
  { key: "track_main", label: "타이틀" },
  { key: "track_code", label: "트랙 코드" },
  { key: "isrc", label: "ISRC" },
  { key: "commission_rate", label: "수익률" },
  { key: "performance_royalties_rate", label: "실연권료" },
  { key: "album_name", label: "앨범명" },
  { key: "musician_name", label: "뮤지션" },
  { key: "genre_depth4", label: "장르" },
  { key: "mp3_ar", label: "MP3" },
  { key: "wav_ar", label: "WAV" },
  { key: "created_date", label: "등록일" },
  { key: "actions", label: "관리" },
];

const LANGUAGES = [
  { value: "한국어", label: "한국어" },
  { value: "영어", label: "영어" },
  { value: "기타", label: "기타" },
];

const GENRES = [
  { value: "트로트", label: "트로트" },
  { value: "Ballad (국내)", label: "발라드 (국내)" },
  { value: "Blues (국내)", label: "블루스 (국내)" },
  { value: "Dance (국내)", label: "댄스 (국내)" },
  { value: "Folk (국내)", label: "포크 (국내)" },
  { value: "R&B / Soul (국내)", label: "알앤비 / 소울 (국내)" },
  { value: "Rap / Hip-hop (국내)", label: "랩 / 힙합 (국내)" },
  { value: "Rock (국내)", label: "록 (국내)" },
  { value: "Electronica (국내)", label: "일렉트로니카 (국내)" },
  { value: "CCM (국내)", label: "CCM (국내)" },
  { value: "Jazz (국내)", label: "재즈 (국내)" },
  { value: "OST (국내)", label: "OST (국내)" },
  { value: "Blues (국외)", label: "블루스 (국외)" },
  { value: "Country (국외)", label: "컨트리 (국외)" },
  { value: "Electronica (국외)", label: "일렉트로니카 (국외)" },
  { value: "Folk (국외)", label: "포크 (국외)" },
  { value: "Pop (국외)", label: "팝 (국외)" },
  { value: "EDM (국외)", label: "EDM (국외)" },
  { value: "R&B / Soul (국외)", label: "알앤비 / 소울 (국외)" },
  { value: "Rap / Hip-hop (국외)", label: "랩 / 힙합 (국외)" },
  { value: "Rock (국외)", label: "록 (국외)" },
  { value: "CCM (국외)", label: "CCM (국외)" },
  { value: "Jazz (국외)", label: "재즈 (국외)" },
  { value: "OST (국외)", label: "OST (국외)" },
  { value: "한국전통음악", label: "한국전통음악" },
  { value: "어린이음악", label: "어린이음악" },
  { value: "종교음악", label: "종교음악" },
  { value: "Classic", label: "클래식" },
  { value: "New Age", label: "뉴에이지" },
  { value: "뮤직테라피", label: "뮤직테라피" },
  { value: "기타", label: "기타" },
  { value: "월드뮤직", label: "월드뮤직" },
  { value: "Electronica (J-Pop)", label: "일렉트로니카 (J-Pop)" },
  { value: "Pop (J-Pop)", label: "팝 (J-Pop)" },
  { value: "R&B / Soul (J-Pop)", label: "알앤비 / 소울 (J-Pop)" },
  { value: "Rap / Hip-hop (J-Pop)", label: "랩 / 힙합 (J-Pop)" },
  { value: "Rock (J-Pop)", label: "록 (J-Pop)" },
];

const MOODS = [
  { value: "Angry", label: "화난" },
  { value: "Busy & Frantic", label: "광란&들뜬" },
  { value: "Changing Tempo", label: "다이내믹 템포" },
  { value: "Chasing", label: "추적" },
  { value: "Dark", label: "어둠" },
  { value: "Dreamy", label: "몽환" },
  { value: "Eccentric", label: "괴짜" },
  { value: "Elegant", label: "우아함" },
  { value: "Epic", label: "웅장" },
  { value: "Euphoric", label: "유쾌" },
  { value: "Fear", label: "두려움" },
  { value: "Floating", label: "떠있는 느낌" },
  { value: "Funny", label: "코믹" },
  { value: "Glamorous", label: "화려함" },
  { value: "Happy", label: "행복" },
  { value: "Heavy & Ponderous", label: "무게감" },
  { value: "Hopeful", label: "희망" },
  { value: "Laid Back", label: "여유" },
  { value: "Marching", label: "행진" },
  { value: "Mysterious", label: "미스테리" },
  { value: "Peaceful", label: "평화로움" },
  { value: "Quirky", label: "별난" },
  { value: "Relaxing", label: "편안함" },
  { value: "Restless", label: "불안정함" },
  { value: "Romantic", label: "로맨틱" },
  { value: "Running", label: "운동" },
  { value: "Sad", label: "슬픔" },
  { value: "Scary", label: "무서움" },
  { value: "Sentimental", label: "감상적임" },
  { value: "Sexy", label: "섹시" },
  { value: "Smooth", label: "부드러움" },
  { value: "Sneaking", label: "은밀함" },
  { value: "Suspense", label: "긴장감" },
  { value: "Weird", label: "기묘함" },
  { value: "All moods", label: "전체 무드" },
];

const Tracks = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [selected, setSelected] = useState(null);
  const [editFields, setEditFields] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [musicians, setMusicians] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [mp3File, setMp3File] = useState(null);
  const [wavFile, setWavFile] = useState(null);
  const [mp3UploadProgress, setMp3UploadProgress] = useState(0);
  const [wavUploadProgress, setWavUploadProgress] = useState(0);
  const [uploadingMp3, setUploadingMp3] = useState(false);
  const [uploadingWav, setUploadingWav] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [tempPage, setTempPage] = useState("1");

  const handleSearch = () => {
    setSearch(searchInput);
    setPage(1);
    setTempPage("1");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: rows, error } = await supabase.rpc(
        "get_tracks_with_album_and_musician",
        {
          search: search || null,
          page: parseInt(page),
        }
      );

      if (error) throw error;

      setData(rows || []);

      // 전체 페이지 수를 계산하기 위해 전체 개수를 가져옵니다
      let countQuery = supabase.from("track").select("*", { count: "exact" });

      if (search) {
        countQuery = countQuery.or(
          `track_name_kr.ilike.%${search}%,track_code.ilike.%${search}%,isrc.ilike.%${search}%`
        );
      }

      const { count, error: countError } = await countQuery;
      if (countError) throw countError;

      setTotalPages(Math.max(1, Math.ceil((count || 1) / PAGE_SIZE)));
    } catch (error) {
      console.error("Error fetching data:", error);
      toast({
        title: "데이터를 불러오는데 실패했습니다.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [search, page]);

  useEffect(() => {
    const fetchMusicians = async () => {
      try {
        const { data, error } = await supabase
          .from("musician")
          .select("*")
          .order("created_date", { ascending: false });

        if (error) throw error;
        setMusicians(data || []);
      } catch (error) {
        console.error("Error fetching musicians:", error);
        toast({
          title: "뮤지션 목록을 불러오는데 실패했습니다.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    if (modalOpen) {
      fetchMusicians();
    }
  }, [modalOpen]);

  useEffect(() => {
    if (editModalOpen && selected) {
      const fetchMusicians = async () => {
        if (!selected.musician) return;
        const { data: musicianRow, error: musicianError } = await supabase
          .from("musician")
          .select("*")
          .eq("id", selected.musician)
          .single();
        if (musicianError || !musicianRow) return setMusicians([]);
        const { data: allMusicians, error: allError } = await supabase
          .from("musician")
          .select("*")
          .eq("user", musicianRow.user)
          .order("created_date", { ascending: false });
        if (allError) return setMusicians([]);
        setMusicians(allMusicians || []);
      };
      fetchMusicians();
    }
  }, [editModalOpen, selected]);

  const handleRowClick = (row) => {
    setSelected(row);
    // album_name과 musician_name을 제외한 필드만 저장
    const { album_name, musician_name, ...editData } = row;
    setEditFields({
      ...editData,
      mood: Array.isArray(editData.mood)
        ? editData.mood
        : typeof editData.mood === "string" && editData.mood.startsWith("[")
        ? JSON.parse(editData.mood)
        : [],
    });
    setEditModalOpen(true);
  };

  const handleEditChange = (key, value) => {
    setEditFields((prev) => ({ ...prev, [key]: value }));
  };

  const handleMoodToggle = (mood) => {
    setEditFields((prev) => {
      const moodArr = Array.isArray(prev.mood) ? prev.mood : [];
      if (moodArr.includes(mood.value)) {
        return { ...prev, mood: moodArr.filter((m) => m !== mood.value) };
      } else {
        return { ...prev, mood: [...moodArr, mood.value] };
      }
    });
  };

  const getAudioDuration = (file) => {
    return new Promise((resolve) => {
      const audio = new Audio();
      audio.addEventListener("loadedmetadata", () => {
        resolve(Math.floor(audio.duration));
      });
      audio.src = URL.createObjectURL(file);
    });
  };

  const uploadFile = async (file, path, file_track_code) => {
    try {
      const fileExt = file.name.split(".").pop()?.toLowerCase() || path;
      const timestamp = new Date().getTime();
      const cleanTrackCode = (editFields.track_code || "track").replace(
        /[^a-zA-Z0-9]/g,
        "_"
      );
      const fileName = `${cleanTrackCode}_${timestamp}.${fileExt}`;
      const filePath = `${path}/${fileName}`;
      setUploadStatus(
        `"${file.name}" (${path.toUpperCase()}) 파일 업로드 중...`
      );
      const { data, error: urlError } = await supabase.storage
        .from("track")
        .createSignedUploadUrl(filePath);
      if (urlError || !data?.signedUrl) {
        throw new Error("Signed URL 발급 실패");
      }
      const signedUrl = data.signedUrl;
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("PUT", signedUrl, true);
        xhr.setRequestHeader(
          "Content-Type",
          file.type || (path === "mp3" ? "audio/mpeg" : "audio/wav")
        );
        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable) {
            if (path === "mp3")
              setMp3UploadProgress(Math.round((e.loaded / e.total) * 100));
            if (path === "wav")
              setWavUploadProgress(Math.round((e.loaded / e.total) * 100));
          }
        };
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve();
          } else {
            reject(new Error(`업로드 실패: ${xhr.status} ${xhr.statusText}`));
          }
        };
        xhr.onerror = () => {
          reject(new Error("네트워크 오류가 발생했습니다."));
        };
        xhr.send(file);
      });
      const { data: publicUrlData } = supabase.storage
        .from("track")
        .getPublicUrl(filePath);
      return publicUrlData?.publicUrl;
    } catch (error) {
      throw error;
    }
  };

  const handleUpdate = async () => {
    try {
      setIsLoading(true);
      setMp3UploadProgress(0);
      setWavUploadProgress(0);
      setUploadStatus("");
      // 필수값 검증
      const requiredFields = {
        track_number: "트랙 번호",
        track_name_kr: "트랙명",
        musician: "뮤지션",
        vocal_language: "언어",
        genre_depth4: "장르",
        composer_kr: "작곡가",
        composer_en: "작곡가(영문)",
      };
      const missingFields = Object.entries(requiredFields)
        .filter(([key]) => !editFields[key])
        .map(([_, label]) => label);
      if (missingFields.length > 0) {
        toast({
          title: "필수 정보 누락",
          description: `${missingFields.join(", ")}`,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setIsLoading(false);
        return;
      }
      let mp3Url = editFields.mp3_ar;
      let wavUrl = editFields.wav_ar;
      // 파일 확장자/용량 체크 및 업로드
      if (mp3File) {
        if (
          !mp3File.name.toLowerCase().endsWith(".mp3") ||
          !(mp3File.type === "audio/mpeg" || mp3File.type === "audio/mp3")
        ) {
          toast({
            title: "잘못된 파일 형식",
            description: "MP3 파일만 업로드할 수 있습니다.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setIsLoading(false);
          return;
        }
        if (mp3File.size > 50 * 1024 * 1024) {
          toast({
            title: "파일 크기 초과",
            description: "MP3 파일은 50MB를 초과할 수 없습니다.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setIsLoading(false);
          return;
        }
        mp3Url = await uploadFile(
          mp3File,
          "mp3",
          editFields.track_code || "track"
        );
      }
      if (wavFile) {
        if (
          !wavFile.name.toLowerCase().endsWith(".wav") ||
          !(wavFile.type === "audio/wav" || wavFile.type === "audio/x-wav")
        ) {
          toast({
            title: "잘못된 파일 형식",
            description: "WAV 파일만 업로드할 수 있습니다.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setIsLoading(false);
          return;
        }
        if (wavFile.size > 300 * 1024 * 1024) {
          toast({
            title: "파일 크기 초과",
            description: "WAV 파일은 300MB를 초과할 수 없습니다.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setIsLoading(false);
          return;
        }
        wavUrl = await uploadFile(
          wavFile,
          "wav",
          editFields.track_code || "track"
        );
      }
      const { error } = await supabase
        .from("track")
        .update({
          ...editFields,
          mood: JSON.stringify(editFields.mood),
          track_number: parseInt(editFields.track_number),
          mp3_ar: mp3Url,
          wav_ar: wavUrl,
          over_19: !!editFields.over_19,
        })
        .eq("id", selected.id);
      if (error) throw error;
      toast({
        title: "트랙 정보가 수정되었습니다.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      setEditModalOpen(false);
      fetchData();
      setMp3File(null);
      setWavFile(null);
      setMp3UploadProgress(0);
      setWavUploadProgress(0);
      setUploadStatus("");
    } catch (error) {
      toast({
        title: "트랙 수정 실패",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setTempPage(page.toString());
  }, [page]);

  const handlePageInput = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      setTempPage(value);
    }
  };

  const handlePageMove = () => {
    const num = parseInt(tempPage, 10);
    if (num >= 1 && num <= totalPages) {
      setPage(num);
    } else {
      setTempPage(page.toString());
      toast({
        title: "올바른 페이지 번호를 입력하세요.",
        status: "warning",
        duration: 2000,
      });
    }
  };

  const handlePageBlur = () => {
    handlePageMove();
  };

  const handleFileDownload = async (fileUrl, fileName) => {
    if (!fileUrl) return;
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("파일 다운로드 실패");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast({
        title: "다운로드 실패",
        status: "error",
        duration: 2000,
      });
    }
  };

  return (
    <Box maxW="1400px" mx="auto" py={8}>
      <Flex mb={4} gap={2} align="center">
        <Input
          placeholder="트랙명, 트랙 코드, ISRC 검색"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyPress={handleKeyPress}
          width="300px"
        />
        <Button colorScheme="blue" onClick={handleSearch}>
          검색
        </Button>
      </Flex>

      <Box overflowX="auto" bg="white" borderRadius="xl" boxShadow="md">
        <Table size="sm">
          <Thead bg="gray.50">
            <Tr>
              {columns.map((col) => (
                <Th key={col.key}>{col.label}</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {loading ? (
              <Tr>
                <Td colSpan={columns.length} textAlign="center">
                  <Spinner />
                </Td>
              </Tr>
            ) : data.length === 0 ? (
              <Tr>
                <Td colSpan={columns.length} textAlign="center">
                  <Text color="gray.400">데이터 없음</Text>
                </Td>
              </Tr>
            ) : (
              data.map((row) => (
                <Tr key={row.id}>
                  {columns.map((col) => (
                    <Td
                      key={col.key}
                      maxW="200px"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {col.key === "actions" ? (
                        <Button
                          size="sm"
                          colorScheme="blue"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRowClick(row);
                          }}
                        >
                          수정
                        </Button>
                      ) : col.key === "created_date" ? (
                        row[col.key] ? (
                          new Date(row[col.key]).toLocaleDateString()
                        ) : (
                          "-"
                        )
                      ) : col.key === "mp3_ar" || col.key === "wav_ar" ? (
                        row[col.key] ? (
                          <Button
                            size="xs"
                            colorScheme="blue"
                            variant="link"
                            onClick={(e) => {
                              e.stopPropagation();
                              const fileName = `${
                                row.track_name_kr || "track"
                              }_${col.key === "mp3_ar" ? "mp3" : "wav"}`;
                              handleFileDownload(row[col.key], fileName);
                            }}
                          >
                            다운로드
                          </Button>
                        ) : (
                          "-"
                        )
                      ) : col.key === "track_main" ? (
                        row[col.key] === true || row[col.key] === "true" ? (
                          <Tag size="sm">✔️</Tag>
                        ) : (
                          "-"
                        )
                      ) : col.key === "genre_depth4" ? (
                        row[col.key] ? (
                          <Tag size="sm" colorScheme="teal">
                            {GENRES.find(
                              (genre) => genre.value === row[col.key]
                            )?.label || row[col.key]}
                          </Tag>
                        ) : (
                          "-"
                        )
                      ) : col.key === "mood" ? (
                        <Wrap>
                          {typeof row[col.key] === "string"
                            ? (() => {
                                const moods = row[col.key]
                                  .replace(/[[\]"']/g, "")
                                  .split(/,|\//)
                                  .filter((word) => word.trim() !== "")
                                  .map((m) => m.trim());
                                return moods.map((m, i) => (
                                  <WrapItem key={i}>
                                    <Tag size="sm" colorScheme="teal" mr={1}>
                                      {MOODS.find((mood) => mood.value === m)
                                        ?.label || m}
                                    </Tag>
                                  </WrapItem>
                                ));
                              })()
                            : "-"}
                        </Wrap>
                      ) : col.key === "performance_royalties_rate" ? (
                        row[col.key] !== null && row[col.key] !== undefined ? (
                          `${parseFloat(row[col.key]).toFixed(2)}%`
                        ) : (
                          "-"
                        )
                      ) : col.key === "commission_rate" ? (
                        row[col.key] !== null && row[col.key] !== undefined ? (
                          `${parseFloat(row[col.key]).toFixed(2)}%`
                        ) : (
                          "-"
                        )
                      ) : (
                        row[col.key] ?? "-"
                      )}
                    </Td>
                  ))}
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Flex justify="center" mt={4} gap={2} align="center">
        <Button
          size="sm"
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          isDisabled={page === 1}
        >
          이전
        </Button>
        <Input
          value={tempPage}
          onChange={handlePageInput}
          onBlur={handlePageBlur}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handlePageMove();
            }
          }}
          size="sm"
          width="50px"
          textAlign="center"
          fontSize="sm"
        />
        <Button size="sm" onClick={handlePageMove}>
          이동
        </Button>
        <Text fontSize="sm" px={2}>
          / {totalPages}
        </Text>
        <Button
          size="sm"
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          isDisabled={page === totalPages}
        >
          다음
        </Button>
      </Flex>

      {editModalOpen && selected && (
        <Modal
          isOpen={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          size="xl"
        >
          <ModalOverlay backdropFilter="blur(10px)" />
          <ModalContent maxW="800px" borderRadius="xl" boxShadow="xl">
            <ModalHeader
              bg="blue.50"
              borderTopRadius="xl"
              py={4}
              fontSize="xl"
              fontWeight="bold"
              color="blue.700"
            >
              트랙 정보 수정
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody p={6}>
              <VStack spacing={4}>
                <HStack width="100%" spacing={4}>
                  <FormControl flex={1} isRequired>
                    <FormLabel fontWeight="medium" color="gray.700">
                      트랙 번호
                    </FormLabel>
                    <Input
                      value={editFields.track_number ?? ""}
                      onChange={(e) =>
                        handleEditChange("track_number", e.target.value)
                      }
                      type="number"
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      타이틀 곡
                    </FormLabel>
                    <Checkbox
                      isChecked={
                        editFields.track_main === true ||
                        editFields.track_main === "true"
                      }
                      onChange={(e) =>
                        handleEditChange("track_main", e.target.checked)
                      }
                      colorScheme="blue"
                    >
                      타이틀 곡으로 지정
                    </Checkbox>
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      가창/연주
                    </FormLabel>
                    <Checkbox
                      isChecked={
                        editFields.vocal === true || editFields.vocal === "true"
                      }
                      onChange={(e) =>
                        handleEditChange("vocal", e.target.checked)
                      }
                      colorScheme="blue"
                    >
                      가창곡
                    </Checkbox>
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      19금 여부
                    </FormLabel>
                    <Checkbox
                      isChecked={editFields.over_19 === true}
                      onChange={(e) =>
                        handleEditChange("over_19", e.target.checked)
                      }
                      colorScheme="blue"
                    >
                      19금 (성인)
                    </Checkbox>
                  </FormControl>
                </HStack>
                <Box width="100%">
                  <FormControl isRequired>
                    <FormLabel fontWeight="medium" color="gray.700">
                      트랙명
                    </FormLabel>
                  </FormControl>
                  <Text fontSize="sm" color="gray.500" mb={2}>
                    국문에도 영어가 가능합니다. 국문 트랙명은 한국 발매
                    이름이고, 영문 트랙명은 해외 발매 이름이 됩니다.
                  </Text>
                  <HStack width="100%" spacing={4}>
                    <FormControl flex={1} isRequired>
                      <Input
                        value={editFields.track_name_kr ?? ""}
                        onChange={(e) =>
                          handleEditChange("track_name_kr", e.target.value)
                        }
                        placeholder="국문 트랙명"
                        borderRadius="md"
                        focusBorderColor="blue.400"
                      />
                    </FormControl>
                    <FormControl flex={1} isRequired>
                      <Input
                        value={editFields.track_name_en ?? ""}
                        onChange={(e) =>
                          handleEditChange("track_name_en", e.target.value)
                        }
                        placeholder="영문 트랙명"
                        borderRadius="md"
                        focusBorderColor="blue.400"
                      />
                    </FormControl>
                  </HStack>
                </Box>
                <HStack width="100%" spacing={4}>
                  <FormControl flex={1} isRequired>
                    <FormLabel fontWeight="medium" color="gray.700">
                      뮤지션
                    </FormLabel>
                    <Select
                      value={editFields.musician || ""}
                      onChange={(e) =>
                        handleEditChange("musician", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    >
                      <option value="">선택하세요</option>
                      {musicians.map((musician) => (
                        <option key={musician.id} value={musician.id}>
                          {musician.name_musician}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl flex={1} isRequired>
                    <FormLabel fontWeight="medium" color="gray.700">
                      언어
                    </FormLabel>
                    <Select
                      value={
                        LANGUAGES.find(
                          (l) => l.value === editFields.vocal_language
                        )?.label || ""
                      }
                      onChange={(e) => {
                        const selected = LANGUAGES.find(
                          (l) => l.label === e.target.value
                        );
                        handleEditChange(
                          "vocal_language",
                          selected ? selected.value : ""
                        );
                      }}
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    >
                      <option value="">선택하세요</option>
                      {LANGUAGES.map((lang) => (
                        <option key={lang.value} value={lang.label}>
                          {lang.label}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl flex={1} isRequired>
                    <FormLabel fontWeight="medium" color="gray.700">
                      장르
                    </FormLabel>
                    <Select
                      value={
                        GENRES.find((g) => g.value === editFields.genre_depth4)
                          ?.label || ""
                      }
                      onChange={(e) => {
                        const selected = GENRES.find(
                          (g) => g.label === e.target.value
                        );
                        handleEditChange(
                          "genre_depth4",
                          selected ? selected.value : ""
                        );
                      }}
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    >
                      <option value="">선택하세요</option>
                      {GENRES.map((genre) => (
                        <option key={genre.value} value={genre.label}>
                          {genre.label}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </HStack>
                <HStack width="100%" spacing={4}>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      작사가
                    </FormLabel>
                    <Input
                      value={editFields.lyricist_kr ?? ""}
                      onChange={(e) =>
                        handleEditChange("lyricist_kr", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      작사가 (영문)
                    </FormLabel>
                    <Input
                      value={editFields.lyricist_en ?? ""}
                      onChange={(e) =>
                        handleEditChange("lyricist_en", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                </HStack>
                <HStack width="100%" spacing={4}>
                  <FormControl flex={1} isRequired>
                    <FormLabel fontWeight="medium" color="gray.700">
                      작곡가
                    </FormLabel>
                    <Input
                      value={editFields.composer_kr ?? ""}
                      onChange={(e) =>
                        handleEditChange("composer_kr", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1} isRequired>
                    <FormLabel fontWeight="medium" color="gray.700">
                      작곡가 (영문)
                    </FormLabel>
                    <Input
                      value={editFields.composer_en ?? ""}
                      onChange={(e) =>
                        handleEditChange("composer_en", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                </HStack>
                <HStack width="100%" spacing={4}>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      편곡가
                    </FormLabel>
                    <Input
                      value={editFields.arranger_kr ?? ""}
                      onChange={(e) =>
                        handleEditChange("arranger_kr", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      편곡가 (영문)
                    </FormLabel>
                    <Input
                      value={editFields.arranger_en ?? ""}
                      onChange={(e) =>
                        handleEditChange("arranger_en", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                </HStack>
                <FormControl>
                  <FormLabel fontWeight="medium" color="gray.700">
                    가사
                  </FormLabel>
                  <Textarea
                    value={editFields.lyrics ?? ""}
                    onChange={(e) => handleEditChange("lyrics", e.target.value)}
                    rows={5}
                    borderRadius="md"
                    focusBorderColor="blue.400"
                  />
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="medium" color="gray.700">
                    메모
                  </FormLabel>
                  <Textarea
                    value={editFields.description ?? ""}
                    onChange={(e) =>
                      handleEditChange("description", e.target.value)
                    }
                    rows={3}
                    borderRadius="md"
                    focusBorderColor="blue.400"
                  />
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="medium" color="gray.700">
                    분위기 (다중 선택)
                  </FormLabel>
                  <Box p={4} bg="blue.50" borderRadius="lg">
                    <Flex wrap="wrap" gap={2}>
                      {MOODS.map((mood) => (
                        <Button
                          key={mood.value}
                          size="sm"
                          variant={
                            editFields.mood?.includes(mood.value)
                              ? "solid"
                              : "outline"
                          }
                          colorScheme="blue"
                          onClick={() => handleMoodToggle(mood)}
                        >
                          {mood.label}
                        </Button>
                      ))}
                    </Flex>
                  </Box>
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="medium" color="gray.700">
                    MP3 파일 (최대 50MB)
                  </FormLabel>
                  <Input
                    type="file"
                    accept=".mp3"
                    onChange={(e) => setMp3File(e.target.files[0])}
                    isDisabled={uploadingMp3 || isLoading}
                    borderRadius="md"
                    p={1}
                  />
                  {uploadingMp3 && (
                    <Progress
                      value={mp3UploadProgress}
                      size="sm"
                      colorScheme="blue"
                      mt={2}
                    />
                  )}
                  {editFields.mp3_ar && !uploadingMp3 && (
                    <a
                      href={editFields.mp3_ar}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#3182ce",
                        textDecoration: "underline",
                        wordBreak: "break-all",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      기존 파일 열기
                    </a>
                  )}
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="medium" color="gray.700">
                    WAV 파일 (최대 300MB)
                  </FormLabel>
                  <Input
                    type="file"
                    accept=".wav"
                    onChange={(e) => setWavFile(e.target.files[0])}
                    isDisabled={uploadingWav || isLoading}
                    borderRadius="md"
                    p={1}
                  />
                  {uploadingWav && (
                    <Progress
                      value={wavUploadProgress}
                      size="sm"
                      colorScheme="green"
                      mt={2}
                    />
                  )}
                  {editFields.wav_ar && !uploadingWav && (
                    <a
                      href={editFields.wav_ar}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#3182ce",
                        textDecoration: "underline",
                        wordBreak: "break-all",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      기존 파일 열기
                    </a>
                  )}
                </FormControl>
                {uploadStatus && (
                  <Text color="blue.500" fontSize="sm" mt={2}>
                    {uploadStatus}
                  </Text>
                )}
                <HStack width="100%" spacing={4}>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      앨범 ID
                    </FormLabel>
                    <Input
                      value={editFields.album ?? ""}
                      onChange={(e) =>
                        handleEditChange("album", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      트랙 코드
                    </FormLabel>
                    <Input
                      value={editFields.track_code ?? ""}
                      onChange={(e) =>
                        handleEditChange("track_code", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      수익률(commission_rate)
                    </FormLabel>
                    <Input
                      value={editFields.commission_rate ?? ""}
                      onChange={(e) =>
                        handleEditChange("commission_rate", e.target.value)
                      }
                      type="number"
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                </HStack>
                <HStack width="100%" spacing={4}>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      실연권료
                    </FormLabel>
                    <Input
                      value={editFields.performance_royalties_rate ?? ""}
                      onChange={(e) =>
                        handleEditChange(
                          "performance_royalties_rate",
                          e.target.value
                        )
                      }
                      type="number"
                      placeholder="0.00"
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      UCI 트랙 코드
                    </FormLabel>
                    <Input
                      value={editFields.uci_track_code ?? ""}
                      onChange={(e) =>
                        handleEditChange("uci_track_code", e.target.value)
                      }
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      UPC
                    </FormLabel>
                    <Input
                      value={editFields.upc ?? ""}
                      onChange={(e) => handleEditChange("upc", e.target.value)}
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                </HStack>
                <HStack width="100%" spacing={4}>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      ISRC
                    </FormLabel>
                    <Input
                      value={editFields.isrc ?? ""}
                      onChange={(e) => handleEditChange("isrc", e.target.value)}
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontWeight="medium" color="gray.700">
                      유튜브 URL
                    </FormLabel>
                    <Input
                      value={editFields.youtube_url ?? ""}
                      onChange={(e) =>
                        handleEditChange("youtube_url", e.target.value)
                      }
                      placeholder="https://www.youtube.com/watch?v=..."
                      borderRadius="md"
                      focusBorderColor="blue.400"
                    />
                  </FormControl>
                </HStack>
              </VStack>
            </ModalBody>
            <ModalFooter p={4} borderTopWidth={1} borderColor="gray.200">
              <Button
                variant="ghost"
                mr={3}
                onClick={() => setEditModalOpen(false)}
              >
                취소
              </Button>
              <Button
                colorScheme="blue"
                onClick={handleUpdate}
                isLoading={isLoading}
                loadingText="저장 중..."
              >
                저장
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </Box>
  );
};

export default Tracks;
